"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = require("../main");
var constantsClasses_1 = require("../data/constantsClasses");
var waitForElement_1 = require("../helpers/waitForElement");
var constants_1 = require("../data/constants");
var TrengoModal = /** @class */ (function () {
    function TrengoModal() {
        var _this = this;
        this.stickyButtonsElement = document.querySelector("[".concat(constants_1.DATA_STICKY_BUTTONS, "]"));
        (0, waitForElement_1.waitForElement)('#trengo-web-widget').then(function (element) {
            var _a;
            // Move Trengo button to sticky floating buttons
            (_a = _this.stickyButtonsElement) === null || _a === void 0 ? void 0 : _a.querySelector("[".concat(constants_1.DATA_STICKY_BUTTONS_WRAPPER, "]")).appendChild(element);
            _this.header = document.querySelector("[".concat(constants_1.DATA_HEADER, "]"));
            _this.parent = element.querySelector('.TrengoWidgetLauncher__iframe');
            _this.iframeLauncher = _this.parent.firstElementChild;
            _this.iframePanel = element.querySelector('.TrengoWidgetPanel__iframe').firstElementChild;
            setTimeout(function () {
                _this.btnLauncher = _this.iframeLauncher.contentWindow.document.querySelector('.launcher-container');
                _this.btnPanel = _this.iframePanel.contentWindow.document.querySelector('.close-widget');
                _this.btnLauncher.addEventListener('click', function () {
                    _this.toggleClasses();
                    if (main_1.contactModal.isActive()) {
                        main_1.contactModal.hideModal();
                    }
                });
                _this.btnPanel.addEventListener('click', function () {
                    _this.removeClasses();
                });
                _this.iframePanel.contentWindow.addEventListener('keydown', function (e) {
                    if (e.key === 'Escape') {
                        _this.removeClasses();
                    }
                });
                _this.iframeLauncher.contentWindow.addEventListener('keydown', function (e) {
                    if (e.key === 'Escape') {
                        _this.removeClasses();
                    }
                });
                window.addEventListener('keydown', function (e) {
                    if (e.key === 'Escape') {
                        _this.removeClasses();
                    }
                });
            }, 2000);
        });
    }
    TrengoModal.prototype.hideModal = function () {
        if (this.parent.classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
            this.btnLauncher.click();
        }
    };
    TrengoModal.prototype.showModal = function () {
        if (!this.parent.classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
            this.btnLauncher.click();
        }
    };
    TrengoModal.prototype.toggleClasses = function () {
        this.parent.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
        this.header.classList.toggle(constantsClasses_1.CLASS_MODAL_OPEN);
    };
    TrengoModal.prototype.removeClasses = function () {
        main_1.contactModal.hideModal();
        this.parent.classList.remove(constantsClasses_1.CLASS_ACTIVE);
        this.header.classList.remove(constantsClasses_1.CLASS_MODAL_OPEN);
    };
    return TrengoModal;
}());
exports.default = TrengoModal;
